export const SearchForm = {
  bindings: {
    placeholder: '@',
    query: '<',
    onSubmit: '&',
  },

  template: `
    <form class="search-form"
      ng-submit="$ctrl.onSubmit({ query: $ctrl.query })">
      <div class="input-group">
        <input class="form-control"
          type="text"
          ng-model="$ctrl.query"
          placeholder="{{ $ctrl.placeholder }}..."
          aria-label="{{ $ctrl.placeholder }}...">
        <div class="input-group-addon">
          <button class="btn btn-link p-2" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </form>`,
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchForm.js